import { useQueries } from "@tanstack/react-query";

import { getGetJobQueryOptions } from "../../../../api/generated/endpoints/generation/generation";
import { jobPageInterval } from "../../../../platform/jobs/refetch";
import { useStreamStatus } from "../../../../platform/stream-status";
import { takeOf, type TakeState } from "./cast";

/**
 * Each actor's voiceover, read from its job as a job's page reads one (stream events, then the
 * fallback timer while the stream is down), in the order given; none where there is no job.
 */
export function useTakes(teamId: string, jobIds: readonly (string | null)[]): TakeState[] {
  const stream = useStreamStatus();
  // One read per job: actors without a voiceover yet ask for none.
  const asked = [...new Set(jobIds.filter((jobId) => jobId !== null))];
  const jobs = useQueries({
    queries: asked.map((jobId) => ({
      ...getGetJobQueryOptions(teamId, jobId),
      refetchInterval: (query: { state: { data: Parameters<typeof jobPageInterval>[0] } }) =>
        jobPageInterval(query.state.data, stream),
    })),
  });
  return jobIds.map((jobId) =>
    takeOf(jobId === null ? undefined : jobs[asked.indexOf(jobId)]?.data, jobId),
  );
}
